import MainSaveButton from "./MainSaveButton";

/**
 * Wrapper de MainSaveButton que fuerza width: 100%.
 * Mantiene la misma API (text, onClick, loading, disabled, etc.)
 */
const MainSaveButtonFullWidth = (props) => {
  return <MainSaveButton {...props} fullWidth />;
};

export default MainSaveButtonFullWidth;

